export const en = {
    banner: 'Ad',
    'campaign-group': 'Campaign/Group',
    'campaign-type': 'Campaign type',
    price: 'Price in ad',
    status: 'Status',
    type: 'Type'
};
